// Copyright 2017 Sorama B.V.

import { ISettingsKind } from "datatypes/SettingsKinds/ISettingsKind";
import { BarkBand } from "units/BarkBand";
import { CriticalBand } from "units/CriticalBand";
import { Frequency } from "units/Frequency";
import { Generic } from "units/Generic";
import { Unit } from "units/Unit";

export class AxisKind implements ISettingsKind {
    constructor(
        public readonly name: string,
        public readonly shortName: string,
        public readonly unit: Unit
    ) {}
}

export const LinearGenericAxisKind: AxisKind = new AxisKind("Linear", "Lin", Generic.unitless);
export const LogarithmicGenericAxisKind: AxisKind = new AxisKind("Logarithmic", "Log", Generic.unitless);
export const AxisKinds: AxisKind[] = [LinearGenericAxisKind, LogarithmicGenericAxisKind];

export const LinearBarkBandAxisKind: AxisKind = new AxisKind("Linear", "Lin", BarkBand.averaged);
export const BarkbandAxisKinds = [LinearBarkBandAxisKind];

export const LinearCriticalBandAxisKind: AxisKind = new AxisKind("Linear", "Lin", CriticalBand.averaged);
export const CriticalBandAxisKinds = [LinearCriticalBandAxisKind];

export const LinearFrequencyAxisKind: AxisKind = new AxisKind("Linear", "Lin", Frequency.hertz);
export const LogarithmicFrequencyAxisKind: AxisKind = new AxisKind("Logarithmic", "Log", Frequency.logHertz);
export const FrequencyAxisKinds = [LinearFrequencyAxisKind, LogarithmicFrequencyAxisKind];
